import actions from 'modules/bot/messages/botMessagesActions';

const initialData = {
  loading: false,
  messages: [],
};

export default (state = initialData, { type, payload }) => {

  if (type === actions.FETCH_MESSAGES_STARTED) {
    return {
      ...state,
      messages: [],
      loading: true,
    };
  }

  if (type === actions.FETCH_MESSAGES_SUCCESS) {
    return {
      ...state,
      messages: payload,
      loading: false,
    };
  }

  if (type === actions.FETCH_MESSAGES_ERROR) {
    return {
      ...state,
      messages: [],
      loading: false,
    };
  }

  return state;
};
